import { css } from '@emotion/react';

import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { flex } from 'src/styles/utils';

import { colors } from '../../styles/colors';
import { MediaBP as MQ } from '../../styles/mediaQuery';

export const seoTableContent = (pageType: string) => css`
  color: ${colors.AccentSubscriptionCodGrayColor};
  text-align: left;
  padding: 0 15px 0;
  ${MQ.MediaSm} {
    ${pageType === 'celebs' ? 'padding: 0 15px 0' : 'padding: 0px'}
  }
`;

export const headerStyle = css`
  ${ZeeFontBold(14, 20)};
  margin-bottom: 12px;
  color: ${colors.PrimaryWhiteColor};

  ${MQ.MediaSm} {
    ${ZeeFontBold(18, 24)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontBold(28, 42)};
  }
`;

export const popularList = css`
  ${ZeeFontRegular(12.5, 14)};
  color: ${colors.PrimaryGreyColorAlpha0};
  margin-top: 10px;
`;
export const itemList = (pageType: string) => css`
  ${pageType === `celebs` &&
  `background-color: ${colors.SearchCardBg}; padding: 10px 10px; border-radius: 8px; border: 2px solid ${colors.CharlestonGreen};`}
`;

export const movieTable = (pageType: string) => css`
  border: 2px solid ${colors.CharlestonGreen};
  border-radius: 8px;
  table-layout: fixed;
  width: 100%;
  font-size: 1.25rem;
  box-sizing: border-box;
  text-align: left;
  margin-bottom: 12px;
  padding-bottom: 20px;
  th {
    min-height: 30px;
    padding: 19px 2px 0 13px;
    color: ${colors.PrimaryWhiteColor};
    ${ZeeFontMedium(14, 20)};
    ${MQ.MediaSm} {
      ${ZeeFontMedium(16, 22)};
    }
  }
  strong {
    ${ZeeFontMedium(14, 20)};
    color: ${colors.PrimaryWhiteColor};
    ${MQ.MediaSm} {
      ${ZeeFontMedium(16, 22)};
    }
  }

  td {
    height: 30px;
    padding: 19px 2px 0 13px;
    color: ${colors.PrimaryWhiteColor};
    vertical-align: baseline;
    ${ZeeFontMedium(14, 20)};
    ${MQ.MediaXl} {
      ${ZeeFontMedium(16, 22)}
    }
  }
  ${pageType === 'celebs' ? `background-color: ${colors.SearchCardBg}` : ''}
`;

export const keyValues = css`
  width: 30%;
  ${MQ.MediaMd} {
    width: 20%;
  }
  ${MQ.MediaLg} {
    width: 15%;
  }
`;

export const value = css`
  ${ZeeFontMedium(14, 20)};
  ${MQ.MediaXl} {
    ${ZeeFontMedium(16, 22)};
  }
  ${flex('row', '', 'center')};
  padding: 6px 12px;
  gap: 2px;
  background: ${colors.PrimaryWhiteColorAlpha08};
  border-radius: 999px;
  width: fit-content;
`;

export const valueWrap = css`
  ${flex('row', 'flex-start')}
  flex-wrap: wrap;
  gap: 8px;
`;

export const consumptiondataWrapper = css`
  background: ${colors.PrimaryWhiteColorAlpha04};
  border-radius: 4px;
  padding: 12px 16px;
`;
